
const digest = '45e12a0801ade7a16230b3ffe3f01d2a9bad40853db705b25e1c9f989c51e681';
const classes = {"wrapper":"_wrapper_1a9q3_1","title":"_title_1a9q3_7","description":"_description_1a9q3_12","content":"_content_1a9q3_16"};
const css = `._wrapper_1a9q3_1 {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-grow: 1;
}
._wrapper_1a9q3_1 ._title_1a9q3_7 {
  color: rgb(6, 42, 96);
  font-size: 28px;
  font-weight: 600;
}
._wrapper_1a9q3_1 ._description_1a9q3_12 {
  color: rgb(59, 64, 153);
  font-size: 16px;
}
._wrapper_1a9q3_1 ._content_1a9q3_16 {
  margin-top: 20px;
  flex-grow: 1;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  